import { render, staticRenderFns } from "./MinhaAssinatura.vue?vue&type=template&id=a2f3e138&scoped=true&"
import script from "./MinhaAssinatura.vue?vue&type=script&lang=js&"
export * from "./MinhaAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./MinhaAssinatura.vue?vue&type=style&index=0&id=a2f3e138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f3e138",
  null
  
)

export default component.exports